import { useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { useSession } from '../context/SessionContext';
import { useDispatch } from 'react-redux';
import { Modal, Button } from 'antd';
import { logOut } from '../redux/authentication/actionCreator';

function SessionExpiredPrompt() {
  const { sessionExpired } = useSession();
  const dispatch = useDispatch();
  const { user, removeUser, signoutRedirect, clearStaleState } = useAuth();

  const handleSignOut = () => {
    dispatch(
      logOut(() => {
        removeUser();
        signoutRedirect({
          id_token_hint: user?.id_token,
          // post_logout_redirect_uri: 'http://localhost:3000/', // LOCAL
          // post_logout_redirect_uri: 'https://endow.sec.gov.ph/', // PROD
          // post_logout_redirect_uri: 'https://sec-dms-dev.fortisph.space/', // DEV
          post_logout_redirect_uri: 'https://dms.fortisph.space/',
          // post_logout_redirect_uri: 'https://dms-uat.sec.gov.ph/' // UAT
        });
        clearStaleState();
      }),
    );
  };
  if (!sessionExpired) return null;

  return (
    <Modal
      open={sessionExpired}
      footer={null}
      closable={false}
      centered
      maskClosable={false}
      keyboard={false}
      className="session-expired-modal"
    >
      <div className="text-center p-4">
        <h2 className="text-xl font-semibold mb-2">Session Expired</h2>
        <p className="mb-4 text-gray-600">Your session has expired. Please log in again to continue.</p>
        <Button
          className="bg-primary text-white hover:text-white w-full h-12 p-0 my-6 text-sm font-medium"
          onClick={handleSignOut}
        >
          Login
        </Button>
      </div>
    </Modal>
  );
}

export default SessionExpiredPrompt;
